import { Component, ComponentInterface, Element, h, Host, JSX, Prop } from '@stencil/core';
import { transformTagNames } from '../../global/transform-tag-name';
import { getDataOnFromTheme, WorkbenchTheme } from '../../shared/themes';
import { CounterVariant } from './counter-variant';

/**
 * A Counter component is used to show and highlight a number which can increase and decrease during a user's lifespan.
 * It should only be used for numbers which represent important information.
 */
@Component({
  tag: 'wb-counter',
  styleUrl: 'counter.scss',
  shadow: true,
})
export class CounterComponent implements ComponentInterface {
  @Element()
  public el: HTMLElement;

  /** The number displayed in the counter */
  @Prop({ reflect: true })
  public value: number = 0;

  /** The maximum value allowed. When exceeded, the component will display the max number and a `+`. i.e.`99+`*/
  @Prop({ reflect: true })
  public max: number = 99;

  /**
   * The colour scheme
   * @deprecated Use `data-on` attribute instead
   * */
  @Prop({ reflect: true })
  public theme?: WorkbenchTheme;

  /** The colour variant */
  @Prop({ reflect: true })
  public variant: CounterVariant = 'primary';

  private TagNames = transformTagNames(this, 'wb-counter', ['wb-text']);

  private getLabel(): string {
    const valueAsInt: number = Number.parseInt(String(this.value));
    const maxAsInt: number = Number.parseInt(String(this.max));

    if (isNaN(valueAsInt)) {
      return ' ';
    }

    return valueAsInt <= maxAsInt ? String(valueAsInt) : maxAsInt + '+';
  }

  public render(): JSX.Element {
    const { WbText } = this.TagNames;

    return (
      <Host class="wb-counter" data-digits={this.getLabel().length} data-on={getDataOnFromTheme(this.el, this.theme)}>
        <WbText size="s" strong static>
          {this.getLabel()}
        </WbText>
      </Host>
    );
  }
}
